(function() {
    const sliders = document.querySelectorAll('.jsItemContainerSlider');

    for (let i = 0; i < sliders.length; i++) {
        const sliderEl = sliders[i];

        // Init the slider
        const slider = new Flickity(sliderEl, {
            contain: !sliderEl.classList.contains('ic-plus'),
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            contain: true,
            cellAlign: 'left'
        });

        // Init the slide buttons
        sliderEl.parentElement.addEventListener('click', e => {
            if (e.target.tagName.toLowerCase() === 'button') {
                e.preventDefault();
                if (e.target.classList.contains('prev')) slider.previous();
                else slider.next();
            }
        });
    }
})();
